import { useParams } from "src/routes/hooks";
import ThreadShared from "./ThreadShared";

export default function ThreadByIDShared() {
  const params = useParams();
  const { id } = params;
  return <ThreadShared id={id} />;
}
